module.exports = __webpack_public_path__ + "static/media/bridgerton.56f85ae6.jpg";